import React, { useState } from 'react';
import { User } from '../../../types';
import { FileUp } from 'lucide-react';
import { CsvImportClients } from './CsvImportClients'; // force TS refresh
import { useTranslation } from 'react-i18next';

interface ToolsTabProps {
    user: User;
    onAgencyClientsUpdate?: () => void;
}

export const ToolsTab: React.FC<ToolsTabProps> = ({ user, onAgencyClientsUpdate }) => {
    const { t } = useTranslation('settings');
    const [activeTool, setActiveTool] = useState<'none' | 'csv_import'>('none');

    if (activeTool === 'csv_import') {
        return <CsvImportClients user={user} onBack={() => setActiveTool('none')} onImportComplete={onAgencyClientsUpdate} />;
    }

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-xl font-bold text-slate-800">{t('tools.title')}</h2>
                <p className="text-sm text-slate-500 mt-1">
                    {t('tools.subtitle')}
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div
                    onClick={() => setActiveTool('csv_import')}
                    className="p-6 border border-slate-200 rounded-xl hover:border-black hover:shadow-md cursor-pointer transition-all bg-white group flex flex-col"
                >
                    <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                        <FileUp size={24} />
                    </div>
                    <h3 className="font-bold text-slate-800 mb-2">{t('tools.csv_import_title')}</h3>
                    <p className="text-sm text-slate-500 flex-1">
                        {t('tools.csv_import_desc')}
                    </p>
                </div>
            </div>
        </div>
    );
};
